module.exports = __webpack_public_path__ + "150415ce9e24becb9c435bc554fcf48e.webp";